const SafetyIconDiesel = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M28 16.233V21.883C28 24.767 28 26.209 27.121 27.104C26.243 28 24.828 28 22 28H14C11.172 28 9.757 28 8.879 27.104C8 26.21 8 24.767 8 21.884V19.087C8 16.991 8 15.942 8.553 15.147C9.107 14.352 10.077 14.007 12.018 13.314L20.018 10.459C23.654 9.16199 25.472 8.51299 26.736 9.42799C27.424 9.92499 27.737 10.733 27.88 12"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15 20C15 18.586 15 17.879 15.44 17.44C15.878 17 16.585 17 18 17C19.415 17 20.121 17 20.56 17.44C21 17.879 21 18.586 21 20C21 21.414 21 22.121 20.56 22.56C20.121 23 19.414 23 18 23C16.586 23 15.879 23 15.44 22.56C15 22.122 15 21.415 15 20Z"
      stroke="#171717"
      strokeWidth="1.5"
    />
    <path
      d="M21 17L22 16M15 17L14 16M21 23L22 24M15 23L14 24M11 13.06C11 11.755 11 11.103 11.338 10.653C11.426 10.5363 11.5267 10.4337 11.64 10.345C12.08 10 12.72 10 14 10H14.818C15.325 10 15.579 10 15.788 10.057C16.0674 10.1347 16.3214 10.2848 16.5243 10.4919C16.7272 10.6991 16.872 10.9561 16.944 11.237"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default SafetyIconDiesel
